// extracted by mini-css-extract-plugin
export default {"overlay":"RatingModal_overlay__G3UKc","modal":"RatingModal_modal__DnOKN","modal1":"RatingModal_modal1__TCg+r","item-img":"RatingModal_item-img__Wf3ve"};